import { useSelector } from 'react-redux';
import { RootState } from '../Store';
import { ModalState } from '../Store/Modal/state';

const useGetModal = (): ModalState => {
    return useSelector<RootState, ModalState>(state => state.modal);
};

export default useGetModal;
